import React, {createContext, useContext, useState, useCallback} from "react";
import {useHistory} from "react-router-dom";
import {isEqual, isFunction} from "lodash";

const InspectionsPageUIContext = createContext('');

export function useInspectionsPageUIContext() {
  return useContext(InspectionsPageUIContext);
}

export function InspectionsPageUIProvider({children}) {
  const history = useHistory();
  const [queryParams, setQueryParamsBase] = useState({});
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      for (let key in nextQueryParams) {
        if (nextQueryParams.hasOwnProperty(key) && !nextQueryParams[key]) delete nextQueryParams[key]
      }
      const path = history.location.pathname;
      const newQueryParams = new URLSearchParams(nextQueryParams);
      history.replace(`${path}?${newQueryParams.toString()}`);

      return nextQueryParams;
    });
  }, []);

  const [expandAll, setExpandAll] = useState(false);
  const [columnsMode, setColumnsMode] = useState(
    localStorage.getItem('columnsMode') === 'true'
  );
  const handleColumnsMode = () => {
    setColumnsMode(prev => {
      const newValue = !prev;
      localStorage.setItem('columnsMode', String(newValue));
      return newValue;
    });
  };


  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    expandAll,
    setExpandAll,
    columnsMode,
    handleColumnsMode
  };

  return <InspectionsPageUIContext.Provider value={value}>{children}</InspectionsPageUIContext.Provider>;
}